import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {
    setAuthToken, setIsUserHost, setSessionId, setUsername, setSearchForm,
    setUsuarioId, setErrorMessage
} from '../../stories/actions';
import { getSessionConnecteds } from '../../services/api';
import { isEmpty, isValidEmail, isValidPasswd } from '../../utilities/methods';
import bcrypt from "bcryptjs-react";

import ButtonPay from '../Buttons/ButtonPay';
import Footer from '../Footer/Footer';

import "./Form.css";

const SESSION_ID = process.env.REACT_APP_SESSION_ID;

const FormLogin = ({ users, usersLoggeds, setUsuarioIdAction, setAuthTokenAction, setIsUserHostAction,
    setSessionIdAction, setUsernameAction, errorMessage, setSearchFormAction, setErrorMessageAction }) => {
    const [email, setEmail] = useState("");
    const [passwd, setPasswd] = useState("");
    const [isShowPasswd, setIsShowPasswd] = useState(false);
    const [passwdType, setPasswdType] = useState("password");
    const [iconShowPasswd, setIconShowPasswd] = useState("visibility_off");

    const handlerPasswdType = () => {
        if (isShowPasswd) {
            setPasswdType("password");
            setIconShowPasswd("visibility_off");
        } else {
            setPasswdType("text");
            setIconShowPasswd("visibility");
        }

        setIsShowPasswd(!isShowPasswd);
    };

    const handlerHiddenPasswdType = () => {
        if (isShowPasswd) {
            setPasswdType("password");
            setIconShowPasswd("visibility_off");
        }

        setIsShowPasswd(!isShowPasswd);
    };

    const navigateTo = useNavigate();

    const handlerChangeEmail = (e) => {
        const value = e.target.value;
        setEmail(value);
    };

    const handlerChangePasswd = (e) => {
        const value = e.target.value;
        setPasswd(value);
    };

    const handlerKeyPress = async (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            await handlerSignInWithEmailAndPassword();
        }
    };

    const handlerSignInWithEmailAndPassword = async () => {
        if (!isEmpty(email) || !isEmpty(passwd)) {
            if (!isValidEmail(email)) {
                setErrorMessageAction("O endereço de e-mail fornecido não parece válido. o formato padrão (exemplo@dominio.com).");
            } else if (!isValidPasswd(passwd)) {
                setErrorMessageAction("A senha deve ter pelo menos 8 caracteres, incluindo uma letra maiúscula, um caractere especial e um número.");
            } else {
                const matchedUsers = await Promise.all(
                    users.map(async (user) => {
                        const isMatch = await bcrypt.compare(passwd, user.senha);
                        return user.email === email && isMatch ? user : null;
                    })
                );

                const user = matchedUsers.find(user => user !== null);

                if (user) {
                    if (!user.isAdmin) {
                        await handlerJoinUserSession(user);
                    }
                } else {
                    setErrorMessageAction("Credenciais inválidas. Verifique o email e a senha e tente novamente.");
                }
            }
        }
    };

    const handlerJoinUserSession = async (user) => {
        const roomResponse = await getSessionConnecteds(SESSION_ID);
        const { sessionExists, full } = roomResponse;

        if (sessionExists) {
            if (full) {
                setErrorMessageAction("A sala já está em uso. Por favor, tente novamente mais tarde.");
            } else {
                setUsuarioIdAction(user._id);
                setAuthTokenAction(user.token);
                setUsernameAction(user.nome);

                setIsUserHostAction(false);
                setSessionIdAction(SESSION_ID);

                navigateTo("/home?session=false");
            }
        } else {
            setErrorMessageAction("Sala não encontrada. Não se preocupe, estamos cuidando disso.");
        }
    };

    const handlerUserRegister = () => {
        setErrorMessageAction("");
        setSearchFormAction("register");

        navigateTo("/?page-register=true");
    };

    const handlerUserSendEmail = () => {
        setErrorMessageAction("");
        setSearchFormAction("sendemail");

        navigateTo("/?page-sendemail=true");
    };

    useEffect(() => {
        if (usersLoggeds && Array.isArray(usersLoggeds)) {
            console.warn("Package empty load.");
        }
    }, [usersLoggeds]);

    return (
        <div className='row'>
            <div className='col-md-3'></div>

            <div className='col-md-12 form_container'>
                <div className='form_card'>
                    <div className="mb-2">
                        <small className={errorMessage ? "label_form_style response_message" : "label_form_style"}>{errorMessage}</small>
                    </div>

                    <div className="mb-4">
                        <h4 className='label_form_title_paragraph'>Formulário de login</h4>
                    </div>

                    <div className="mb-2 text-end">
                        <ButtonPay />
                    </div>

                    <div className="mb-2">
                        <label className="label_form_style">Email</label>
                        <input type='email'
                            value={email}
                            placeholder='nome@provedor.com'
                            onChange={handlerChangeEmail}
                            className='form-control input_theme_style' />
                    </div>

                    <div className="mb-4">
                        <label className="label_form_style">Senha</label>
                        <div className='input_group_container'>
                            <input type={passwdType} value={passwd}
                                placeholder='********'
                                onChange={handlerChangePasswd}
                                onKeyDown={handlerKeyPress}
                                className='form-control input_theme_style' />
                            <span className="material-symbols-outlined icon_visible_input_passwd"
                                onClick={handlerPasswdType}
                                onMouseOut={handlerHiddenPasswdType}>{iconShowPasswd}</span>
                        </div>
                    </div>

                    <div className="mb-2 col-md-6">
                        <div className='button_group_container' onClick={handlerSignInWithEmailAndPassword}>
                            <span className="button_group_paragraph_style">Entrar</span>
                            <span className="material-symbols-outlined button_group_icon_style"> login </span>
                        </div>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserRegister}>Registre-se</span>
                    </div>

                    <div className="mb-2">
                        <span className='button_link_form_style' onClick={handlerUserSendEmail}>Esqueci minha senha</span>
                    </div>
                </div>
            </div>

            <div className='col-md-3'></div>

            <Footer />
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setUsuarioIdAction: (usuarioId) => dispatch(setUsuarioId(usuarioId)),
        setAuthTokenAction: (authToken) => dispatch(setAuthToken(authToken)),
        setIsUserHostAction: (isUserHost) => dispatch(setIsUserHost(isUserHost)),
        setSessionIdAction: (sessionId) => dispatch(setSessionId(sessionId)),
        setUsernameAction: (username) => dispatch(setUsername(username)),
        setSearchFormAction: (searchForm) => dispatch(setSearchForm(searchForm)),
        setErrorMessageAction: (errorMessage) => dispatch(setErrorMessage(errorMessage))
    };
};

export default connect(mapStoreToProps, mapActionToProps)(FormLogin);